import {enableProdMode, provideZoneChangeDetection} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {HIGHCHARTS_PROVIDER_CONFIG} from "app/highcharts-provider";
import {RootModule} from "app/root.module";
import {environment} from "environments/environment";
import "./polyfills";
import {provideHighcharts} from "highcharts-angular";

if (environment.production)
{
    enableProdMode();
}

window.CS_COMMIT = environment.version || window.CS_COMMIT;

platformBrowserDynamic()
    .bootstrapModule(RootModule, {
        applicationProviders: [
            provideZoneChangeDetection(),
            provideHighcharts(HIGHCHARTS_PROVIDER_CONFIG)
        ]
    });
